export default "__VITE_ASSET__BhrKXtvZ__"